import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchEmailReports, deleteReportsRequest, updateReport} from '../actions/emailreports';
import {Button, notification} from 'antd'
import axios from 'axios'
import { injectIntl, FormattedMessage, defineMessages  } from 'react-intl';
import '../App.css';
import LoadingControl from '../controls/Loading';
import EmailReportsTable from '../controls/EmailReportsTable'
import EmailReportsWizard from '../controls/AddEmailReport'
import {REPORT_PERIOD, RECEIVER_EMAIL, REPORT_ID, REPORT_URL, REPORT_EVENT_NAME, 
  REPORT_FILTER_NAME, REPORT_FILTER_VALUE, REPORT_PRINTER_ID, REPORT_FILTER} from '../utils/constants'

const reports_url = "/reports";
const report_url = "/report";

const messages = defineMessages({
  success: {
    id: 'Success',
  },  
  success_result: {
    id: 'Success_result',
  },
  error: {
      id: 'Error',
    }, 
});

class EmailReportsPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_report_form: false
    };

    this.edited_report = {};
  }

  componentDidMount() {
    this.props.fetchData(reports_url);
  }

  onEdit(id) {
    this.edited_report = this.props.reports.find(x => x.id === id);

    this.setState({show_report_form : true});
  }

  onCloseReport() {
    this.edited_report = {};
    this.setState({show_report_form : false});
  }

  onAddReport() {
    this.edited_report = {};
    this.setState({show_report_form : true});
  }

  onFinishReport(store) {
    var report_json = this.getReportJson(store);
    if (report_json !== null)
    {
      this.props.updateReport(report_url, report_json);
    }

    this.edited_report = {};
    this.setState({show_report_form : false});
  }

   onSendNow(id) {

    const payload = {
      'id': id
    };

    axios.post('/send_report', payload)
      .then(response => {
      if (response.data.error === undefined)
      {
        notification['success']({
          message: this.props.intl.formatMessage(messages.success),
          description: this.props.intl.formatMessage(messages.success_result),
        });
      }
      else
      {
        notification['error']({
          message: this.props.intl.formatMessage(messages.error),
          description: response.data.error.Response,
          duration: 0
        });  
      }
    })
    .catch(err => {
      notification['error']({
        message: this.props.intl.formatMessage(messages.error),
        description: err.message,
        duration: 0
      });
    });    
  }

  getReportJson(store) { 

    var report_type = store['report_type'];
    if (typeof report_type === 'undefined')
    {
      return null;
    }

    var report = store[report_type];
    var id = report[REPORT_ID];
    var email = report[RECEIVER_EMAIL];
    var period = report[REPORT_PERIOD];
    var url = report[REPORT_URL];

    var addedQuestMark = false;
    for (const [key, value] of Object.entries(report)) 
    {
      if ([REPORT_ID, RECEIVER_EMAIL, REPORT_PERIOD, REPORT_URL].includes(key))
      {
        continue;
      }

      if (value === undefined)
      {
        continue;
      }

      if (!addedQuestMark)
      {
        url += '?'
        addedQuestMark = true;
      }
      else
      {
        url += '&';
      }

      url += key;
      url += '=';
      url += value;
    }

    var result = {
      [RECEIVER_EMAIL] : email,
      [REPORT_PERIOD] : period,
      [REPORT_URL] : url
    };

    if (report_type === "Report.ChangeDeviceStatus" || report_type === "Report.ChangeDeviceConsumables")
    {
      var filter = [];
      var event_name = report[REPORT_URL];
      if (event_name.startsWith("/"))
      {
        event_name = event_name.slice(1);
      }
      
      filter.push({[REPORT_FILTER_NAME] :REPORT_EVENT_NAME, [REPORT_FILTER_VALUE] : event_name});

      if (report["printer_id"] !== undefined)
      {
        filter.push({[REPORT_FILTER_NAME] : REPORT_PRINTER_ID, [REPORT_FILTER_VALUE] : report["printer_id"]});
      }

      result = {...result, ...{[REPORT_FILTER] : filter}};
    }

    if (id !== 0)
    {
      result = {...result, ...{[REPORT_ID] : id}};
    }

    return result;
  }

  render() {
        if(this.props.hasError != null)
        {
          return (
            <div>
              <h3 className="error">{this.props.hasError.message}</h3>
              <Button type="primary" onClick = {() => this.props.fetchData(reports_url)}><FormattedMessage id="Back"/></Button>
              </div>
          );
        }
        else if (this.props.isLoading)
        {
          return (
            <div><LoadingControl/></div>
          );
        }
        else if (this.state.show_report_form)
        {
          return (
            <div className="tabs">
                <EmailReportsWizard report={this.edited_report} onClose = {() => this.onCloseReport()} onFinish = {(store) => this.onFinishReport(store)}/>
          </div>
          );
        }
        else
        {
          return (      
            <div className="tabs">
                <EmailReportsTable data = {this.props.reports} onEdit = {(id) => this.onEdit(id)} onDelete = {(id) => this.props.deleteReports(report_url, [id])} onSendNow = {(id) => this.onSendNow(id)}/>                
                <Button className="button-bottom" type="primary" onClick={() => this.onAddReport()}>
                  <FormattedMessage id="Action.Add"/>
                </Button>
          </div>
          );
        }
  }
}

const mapStateToProps = (state) => {
  return {
      reports: state.emailreports,
      hasError: state.emailReportsHasError,
      isLoading: state.emailReportsIsLoading,
  };
};     

const mapDispatchToProps = (dispatch) => {
return {
    fetchData: (reports_url) => dispatch(fetchEmailReports(reports_url)),
    updateReport: (report_url, report) => dispatch(updateReport(report_url, report)),
    deleteReports: (report_url, items_to_delete) => dispatch(deleteReportsRequest(report_url, items_to_delete))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EmailReportsPane, {withRef: true,}));